/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EmployeeFile { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    userId: number;
    companyId: string;
    catalogId: string;
    originalName: string;
    storedName: string;
    mimeType: string;
    fileSize: number;
    filePath: string;
    isEncrypted?: boolean;
    encryptionIv?: string;
    encryptionAuthTag?: string;
    checksum?: string;
    encryptedDek?: string;
    dekIv?: string;
    dekAuthTag?: string;
    keyVersion?: number;
    isVerified?: boolean;
    status?: EmployeeFile.StatusEnum;
    rejectionReason?: string;
    verifiedBy?: number;
    verifiedOn?: string;
    notes?: string;
}
export namespace EmployeeFile {
    export type StatusEnum = 'pending' | 'verified' | 'rejected';
    export const StatusEnum = {
        Pending: 'pending' as StatusEnum,
        Verified: 'verified' as StatusEnum,
        Rejected: 'rejected' as StatusEnum
    };
}


